export default "__VITE_ASSET__CnLRhpD4__"